import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { AssetSelectedTypeMap } from '../../../../../../../../../store/product/types';

import { EquityItemSelectedDesktop } from './desktop';
import { EquityItemSelectedMobile } from './mobile';
import { EquityItemSelectedTablet } from './tablet';

export namespace EquityItemSelectedTypes {
  export interface Props {
    offer: AssetSelectedTypeMap['equity'];
    onUpdate: (offerUpdated: AssetSelectedTypeMap['equity']) => void;
    hideLateralBar?: boolean;
    isBatchTicket?: boolean;
  }
}

export const EquityItemSelected: React.FC<EquityItemSelectedTypes.Props> = (props) => {
  const equitySelectedItem = useBreakpointValue({
    base: <EquityItemSelectedMobile {...props} />,
    sm: <EquityItemSelectedTablet {...props} />,
    lg: <EquityItemSelectedDesktop {...props} />,
  });

  return equitySelectedItem;
};
